const state= {

};

const getters = {

};

const actions = {
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/user-group`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async createItem({commit}, data){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/user-group`, data)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async assign({commit}, data){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/user-group/assign`, data)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async updateItem({commit}, data){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/user-group/${data.id}`, data)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async deleteItems({commit}, ids){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/user-group`, {
                data:{
                    ids: ids
                }
            })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async removeUserFromGroup({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/user-group/remove-user-from-group`, {
                data:params
            })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },

}

const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
